import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { Relation } from '../types/product';

export interface DashboardProduct {
  id: number;
  articleNumber: string;
  name: string;
  isNew: boolean;
  hasNewStudy: boolean;
  partner: Relation | null;
  indications: Relation[];
}

interface DashboardData {
  recentlyViewed: DashboardProduct[];
  topIndications: { id: number; name: Record<string, string> | string; count: number }[];
}

export function useDashboard(enabled = true) {
  return useQuery<DashboardData>({
    queryKey: ['dashboard'],
    queryFn: () => api<DashboardData>('/dashboard'),
    enabled,
    // Only poll while online — see VIVATISPDB-305 / VIVATISPDB-306.
    refetchInterval: () =>
      typeof navigator !== 'undefined' && navigator.onLine ? 5 * 60 * 1000 : false,
  });
}

export function useTrackProductView() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (productId: number | string) =>
      api(`/products/${productId}/view`, { method: 'POST' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
